import { render, staticRenderFns } from "./MovieShowcase.vue?vue&type=template&id=2debacd2&lang=pug&"
import script from "./MovieShowcase.vue?vue&type=script&lang=js&"
export * from "./MovieShowcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MovieShowcase.vue"
export default component.exports